import { LabelProps, PanelProps } from "@mcleod/components";
import { AbstractSectionPanel } from "./AbstractSectionPanel";
import { LiveDemoLinePanel } from "./LiveDemoLinePanel";

export class LiveDemoLineHeaderPanel extends LiveDemoLinePanel {
    constructor(_sectionPanel: AbstractSectionPanel, props?: Partial<PanelProps>) {
        super(null, null, null, props);
    }

    protected override getNameColumnDef(): Partial<LabelProps> {
        return { ...super.getNameColumnDef(), text: "Name", fontSize: "large" };
    }

    protected override getDescrColumnDef(): Partial<LabelProps> {
        return { ...super.getDescrColumnDef(), text: "Description", fontBold: true, fontSize: "large" };
    }

    protected override addOpenColumn() {
        // Defeat add of open button
    }
}
